import ClientNoteModel from '@/models/crm/client-note.model';

export default class ClientNoteFeaturedModel {
  note!: ClientNoteModel | null;

  total!: number;
}
